import { render, staticRenderFns } from "./PurchaseRequisitionListView.vue?vue&type=template&id=34c6ef95"
import script from "./PurchaseRequisitionListView.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisitionListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports